import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { accountSelectors } from '../selector';
import { RootState } from '../../store';
import { Pharmacy } from '../../models/pharmacy';
import { storeById } from '../../utils/converter';
import { searchPharmacies } from '../../apis/pharmacy';
import { getDistanceFromLatLonInKm } from '../../utils/calculator';

export interface State {
    byId: Dictionary<Pharmacy>;
    loading: Dictionary<boolean>;
}

export const pharmacies = createModel<State>({
    state: {
        byText: {},
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<Pharmacy[]>,
            loadingKey?: string
        ): State => ({
            ...state,
            byId: {
                ...state.byId,
                ...storeById(data)
            },
            ...loadingKey && {
                loading: {
                    ...state.loading,
                    [loadingKey]: false
                }
            }
        }),
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async searchPharmaciesAsync(text: string, rootState: RootState) {
            const textLower = text.toLowerCase();
            const loadingKey = `searchPharmaciesAsync---${textLower}`;

            // const existedPharmacyIds = selectors.getPharmacyIds(rootState.pharmacies, textLower);

            const loading = selectors.getLoading(rootState.pharmacies, loadingKey);
            // const searched = !!existedPharmacyIds && existedPharmacyIds.length > 0;

            // if (!loading && !searched) {
            if (!loading) {
                this.loading(loadingKey, true);
                try {
                    const data = await searchPharmacies(text);
                    if (data) {
                        const coordinates = accountSelectors.getCoordinates(rootState.accounts);
                        // calculate distance
                        data.forEach(x => {
                            x.distance = getDistanceFromLatLonInKm(
                                coordinates && coordinates.latitude,
                                coordinates && coordinates.longitude,
                                x.locationLAT,
                                x.locationLNG
                            );
                        });
                    }
                    this.update(data, loadingKey);
                } catch (e) {
                    window.console.log(e);
                    this.loading(loadingKey, false);
                }
            }
        }
    })
});
